export const enUs = {
    values: {
        Shifts: 'Shifts',
        'New Shift': 'New Shift',
        'Create shifts per Rigs': 'Create shifts per Rig',
        'Successfully saved': 'Successfully saved',
        'Sections successfully saved': 'Sections successfully saved',
        'Shift Name': 'Shift Name',
        Squad: 'Squad',
        'Start (h)': 'Start (h)',
        'End (h)': 'End (h)',
        Color: 'Color',
        'Pipes functions': 'Pipes functions',
        'Pipe Functions Created': 'Pipe Functions Created',
        'Pipe Functions Created Description':
            'The following Pipe functions were created by the plugin. Click a function to open a usage example in the console.',
        Close: 'Close',
        'pipe-fn-getAll-desc': 'Returns all rigs and their configured shifts.',
        'pipe-fn-get-desc': 'Returns the configured shifts for a specific rig.',
        'pipe-fn-isBetween-desc':
            'Checks if a time interval (in ms) overlaps with any shift for the rig. Uses system timezone.',
        'pipe-fn-isBetweenWithTimezone-desc':
            'Checks if a time interval (in ms) overlaps with any shift for the rig using an explicit timezone.',
        'pipe-fn-getMatchedShiftWithTimestamp-desc':
            'Returns the shift that matches a given timestamp (in ms). Uses system timezone.',
        'pipe-fn-getMatchedShiftWithTimestampAndTimezone-desc':
            'Returns the shift that matches a given timestamp (in ms) using an explicit timezone.',
        'pipe-fn-getMatchedShiftBetweenTimestamps-desc':
            'Returns the shift that overlaps with a time interval (in ms). Uses system timezone.',
        'pipe-fn-getMatchedShiftBetweenTimestampsWithTimezone-desc':
            'Returns the shift that overlaps with a time interval (in ms) using an explicit timezone.'
    }
}
